import { useHistory } from "react-router-dom";

const Card = ({ image, title, description, submit, route }) => {
  const history = useHistory();
  const handleSubmit = () => {
    history.push(route);
  };

  return (
    <div
      style={{
        width: "100%",          // take full width available
        maxWidth: "400px",      // but not wider than 400px
        boxSizing: "border-box",
        padding: "1rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "white",
        marginBottom: "1rem",   // spacing between cards on mobile
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <img
        src={image}
        alt=""
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "8px",
          marginBottom: "1rem",
          objectFit: "cover",
        }}
      />
      <div>
        <h2
          style={{
            margin: "0 0 0.5rem 0",
            fontSize: "1.5rem",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            margin: "0 0 1rem 0",
            fontSize: "1rem",
            color: "#555",
          }}
        >
          {description}
        </p>
        <button
          onClick={handleSubmit}
          style={{
            padding: "0.5rem 1rem",
            fontSize: "1rem",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          {submit}
        </button>
      </div>
    </div>
  );
};

export default Card;
